import dayjs from "dayjs";

import { DEPARTMENTS, FOUNDRIES } from "../../constants";
import { EMPLOYEE_TYPES_DICT } from "../../constants/employees";
import {
  PERMISSIONS_KEY,
  PERMISSION_LEVEL_KEYS,
} from "../../constants/permissions";

import ProfileTab from "./tabs/ProfileTab";
import SecurityTab from "./tabs/SecurityTab";
import NotificationsTab from "./tabs/NotificationsTab";

export const sidetabs = [
  { id: "profile", label: "Profile", icon: "User", Component: ProfileTab },
  {
    id: "notifications",
    label: "Notifications",
    icon: "Bell",
    Component: NotificationsTab,
  },
  { id: "security", label: "Security", icon: "Lock", Component: SecurityTab },
];

export const userHasUsersEdit = (permissions = []) =>
  (permissions?.find((p) => p.id === PERMISSIONS_KEY.USERS)?.value || 0) >=
  PERMISSION_LEVEL_KEYS.EDIT;

export const getDefaultValues = (data) => {
  if (!data) return undefined;
  return {
    name: data.name ?? "",
    email: data.email ?? "",
    phone: data.phone ?? "",
    dob: data.dob ?? null,
    doh: data.doh ?? null,
    roleId: data.roleId ?? null,
    locationId: data.locationId ?? null,
    type: data.isFulltime
      ? EMPLOYEE_TYPES_DICT.FULLTIME
      : EMPLOYEE_TYPES_DICT.PARTTIME,
    departmentIds: (data.departments || [])
      .map((id) => DEPARTMENTS.find((d) => d.id === id))
      .filter(Boolean),
    locationIds: (data.locations || [])
      .map((id) => FOUNDRIES.find((f) => f.id === id))
      .filter(Boolean),
    employeeId: data.employeeId ?? "",
    status: data.status ?? "A",
  };
};

export const buildUpdatePayload = ({ form, targetId, canEditOthers }) => {
  const base = {
    id: targetId,
    name: form.name,
    email: form.email,
    phone: form.phone,
  };
  if (!canEditOthers) return base;
  return {
    ...base,
    dob: form.dob ? dayjs(form.dob).toISOString() : null,
    doh: form.doh ? dayjs(form.doh).toISOString() : null,
    roleId: form.roleId != null ? Number(form.roleId) : undefined,
    locationId: form.locationId != null ? Number(form.locationId) : undefined,
    type: Number(form.type || EMPLOYEE_TYPES_DICT.FULLTIME),
    departmentIds: (form.departmentIds || []).map((d) => Number(d.id)),
    locationIds: (form.locationIds || []).map((l) => Number(l.id)),
  };
};
